import BanquetRouteManager from '../lib/BanquetRouteManager';
import RouteStore from '../stores/RouteStore';
import Store from '../models/Store';

function BanquetRouteManagerPlugin(options={}) {
  let store = options.store;

  let getCurrentStore = () => {
    return store;
  };

  return {
    name: 'BanquetRouteManagerPlugin',
    plugContext: function(contextOptions, context) {
      let storeConfig = store ? {
        domain: store.domain,
        slug: store.slug
      } : null;
      let banquetRouteManager = new BanquetRouteManager({storeConfig});

      return {
        name: 'BanquetRouteManagerPlugin',
        plugActionContext: function(actionContext) {
          actionContext.getCurrentStore = getCurrentStore;
          actionContext.buildURLForRoute = banquetRouteManager.buildURLForRoute.bind(banquetRouteManager);
          actionContext.decodeQueryParams = banquetRouteManager.decodeQueryParams.bind(banquetRouteManager);
          actionContext.extractImplicitQueryParamsFromRoute = banquetRouteManager.extractImplicitQueryParamsFromRoute.bind(banquetRouteManager);
        },
        plugComponentContext: function(componentContext) {
          componentContext.getCurrentStore = getCurrentStore;
          componentContext.buildURLForRoute = banquetRouteManager.buildURLForRoute.bind(banquetRouteManager);
        },
        plugStoreContext: function(storeContext) {
          storeContext.getRoutes = banquetRouteManager.getRoutes.bind(banquetRouteManager);
          storeContext.decodeQueryParams = banquetRouteManager.decodeQueryParams.bind(banquetRouteManager);
          storeContext.extractImplicitQueryParamsFromRoute = banquetRouteManager.extractImplicitQueryParamsFromRoute.bind(banquetRouteManager);
          storeContext.makeAbsoluteURLFromPath = banquetRouteManager.makeAbsoluteURLFromPath.bind(banquetRouteManager);
        }
      };
    },
    dehydrate: function() {
      if(!store) {return {};}
      return {store: store.toJS()};
    },
    rehydrate: function(state) {
      if(state.store) {
        store = new Store(state.store);
      }
    }
  };
}

export default BanquetRouteManagerPlugin;



// WEBPACK FOOTER //
// banquet/plugins/BanquetRouteManagerPlugin.js